const searchClient = algoliasearch(
  "UGPL313Z0E",
  "c837d8b67aef8d193f0b6e815c6a59dc"
);
const algoliasearchParams = {
  hitsPerPage: 285,
};

const removeSpace = (s) => {
  return String(s).replace(/[\s+-]/g, "");
};

const preventHashJump = (e) => {
  e.preventDefault();
  const hash = e.target.getAttribute("href");
  if (history.pushState) {
    history.pushState(null, null, hash);
  } else {
    location.hash = hash;
  }
};
const parseCSV=(data)=>{
  if (data==undefined)return 
  return data.split("$$")
}

const parseHyperLink=(data)=>{
  if (data==undefined)return 
  return data.split("$$faqlink$$")
}

const products = [
  "NEO Series",
  "NEO Plus Series",
  "Other LUXE Products",
  "General",
];
const categories = {
  NEOSeries: [
    "Before You Buy",
    "Replacements",
    "Troubleshooting",
    "Installation Help",
  ],
  NEOPlusSeries: [
    "Before You Buy",
    "Replacements",
    "Troubleshooting",
    "Installation Help",
  ],
  OtherLUXEProducts: ["LUXE Bidets", "LUXE Bathroom Products"],
  General: ["Other FAQs"],
};
const subcategories = {
  InstallationHelp: [
    "Part Sizes and Materials",
    "Toilet Setup Questions",
    "Trouble with Leaking",
    "Post-Installation"
  ],
  BeforeYouBuy: [
    "Does It Fit",
    "NEO Features",
    "NEO Plus Features",
    "NEO Models",
    "NEO Plus Models",
    "About Bidets",
  ],
  Replacements: [
    "Alternative Parts",
    "Missing or Broken Parts"
  ],
  Troubleshooting: [
    "Leaking",
    "Water Pressure",
    "Fit Issues",
    "T-Adapter",
    "Nozzle and Guard Gate",
    "Other Parts"
  ],
  LUXEBidets: [
    "Portable Bidet", 
    "Handheld Bidet",
    "Electronic Bidet"
  ],
  LUXEBathroomProducts: [
    "Whift",
    "Water Filter",
    "Toilet Seat",
    "Footstool"
  ],
  OtherFAQs: [
    "Shipping and Orders",
    "Registration and Warranty",
    "Programs and Retailers",
  ],
};

let category_subtext = {
  BeforeYouBuy: "All your pre-purchase questions about toilet set up, installation, and models answered here.",
  Troubleshooting: "We're here to guide you through any difficulties with the installation or use of your bidet.",
  Replacements: "Need a longer hose or a smaller adapter? We got you covered.",
  InstallationHelp:"We're here to guide you through installation every step of the way.",
  LUXEBidets: "Learn more about our other LUXE Bidets here.",
  BathroomProducts: "Learn more about our other LUXE products here.",
  OtherFAQs: "Get your questions about shipping and orders answered here.",
};

let faqdata = {};
var hashChangeDisabled = false;

window.addEventListener("hashchange", (e) => {
  console.log(document.location.hash);
  handleUrl(e);
});

// Make tab buttons and tab content wrappers
for (let curr_product of products) {
  const curr_product_with_space = curr_product;
  curr_product = removeSpace(curr_product);

  // Set up anchors - DOES NOT SEEM TO DO ANYTHING
  //let curr_product_anchor = document.createElement("div");
  //curr_product_anchor.setAttribute("id", curr_product+"-"+curr_product);
  //document.getElementById("productTab-anchors").appendChild(curr_product_anchor);

  // Create products navigation bar
  let curr_product_button = document.createElement("a");
  curr_product_button.setAttribute("class", "tablink");
  if(curr_product == "NEOSeries"){
  	curr_product_button.setAttribute("href", "./customer-support");
  }
  else if(curr_product=="NEOPlusSeries"){
    curr_product_button.setAttribute("href", "./customer-support#neoPlusSeries");
  }
  else if(curr_product=="OtherLUXEProducts"){
  	curr_product_button.setAttribute("href", "./customer-support#otherLUXEProducts");
  }
  else{
  	curr_product_button.setAttribute("href", `#${curr_product}-${curr_product}OtherFAQs`);
  }
  
  //set query id for product button
  curr_product_button.setAttribute("id", "tab-" + curr_product);
  curr_product_button.onclick = function () {
    openPage(curr_product, this);
    if (hashChangeDisabled) {
      return false;
    }
  };

  curr_product_button.textContent = curr_product_with_space;
  document.getElementById("tab-wrapper").appendChild(curr_product_button);

  // Create products qestions category
  let curr_product_content_wrapper = document.createElement("div");
  curr_product_content_wrapper.setAttribute("id", curr_product);
  curr_product_content_wrapper.setAttribute("class", "tabcontent");

  document
    .getElementById("tab-content")
    .appendChild(curr_product_content_wrapper);
}

function openPage(pageName, elmnt) {
  // Hide all products tab content
  const tabcontent = document.getElementsByClassName("tabcontent");
  for (let i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // Initial all products tab
  const tablinks = document.getElementsByClassName("tablink");
  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].style.backgroundColor = "";
    tablinks[i].style.border = "";
    tablinks[i].style.color = "#303133";
    tablinks[i].style.fontWeight = "400";
  }

  // Style active tab
  document.getElementById(pageName).style.display = "block";
  elmnt.style.backgroundColor = "#2A3A5B";
//   elmnt.style.borderTopLeftRadius = "10px";
//   elmnt.style.borderTopRightRadius = "10px";
  elmnt.style.border = "none";
  elmnt.style.borderBottom = "none";
  elmnt.style.color = "white";
//   elmnt.style.fontWeight = "600";
}

// Get data from our Algolia index
const index = searchClient.initIndex("FAQ_QUESTIONS_LIVE");
index.search("", algoliasearchParams).then(({ hits }) => {
  hits.map((hit) => {
    hit.Product = removeSpace(hit.Product);
    hit.Category = removeSpace(hit.Category);
    hit.Subcategory = removeSpace(hit.Subcategory);

    if (hit.Product) {
      if (!(hit.Product in faqdata)) {
        faqdata[hit.Product] = [];
      }

      if (hit.Category) {
        if (!(hit.Category in faqdata[hit.Product])) {
          faqdata[hit.Product][hit.Category] = [];
        }

        if (hit.Subcategory) {
          if (!(hit.Subcategory in faqdata[hit.Product][hit.Category])) {
            faqdata[hit.Product][hit.Category][hit.Subcategory] = [];
          }

          faqdata[hit.Product][hit.Category][hit.Subcategory].push({
            id: hit.objectID,
            question: hit.Question,
            answer: hit.Answer,
            // hyper_text: hit.hyper_text,
            // hyper_link: hit.hyper_link,
            hyper_text: parseCSV(hit.hyper_text),
            hyper_link: parseHyperLink(hit.hyper_link),
            popup_text: hit.popup_text,
          });
        }
      }
    }
  });

  populateNavContents();
  populateCatContents();
  handleUrl();
});

// For debugging purposes: print all the faq from algolia
// console.log(faqdata);

const populateNavContents = () => {
  // populate Categories/Product and Subcategories
  for (let curr_product of products) {
    let css_selector = curr_product.replace(/\s+/g, "");
    let tab_content_wrapper = document.getElementById(css_selector);

    let tab_content = document.createElement("div");
    tab_content.innerHTML = `
    <div class="row">
      <div class="column nav">
        <ul id="${css_selector}-cat" style="list-style-type: none;"></ul>
        <div class="faq-nav-footer">
          <div id="open_identify_pop" class="identifyparts_popup_bottom_nav" role="button" tabindex="0" style="margin-bottom: 10px;"  href = "JavaScript:void(0)" onclick = "openIdentify()"
          aria-haspopup="dialog" aria-expanded="false">
                <div style="font-family: 'Frank Ruhl Libre'; font-size: 25px; font-weight: 500; color: #303133;
                padding: 10px">
                    <p style="width:80%">How to Identify Set-up Parts</p>
                    <span style="position: absolute; right: 10px; top: 10px;">
                    <img src="https://cdn.shopify.com/s/files/1/0563/2848/7080/files/faq-identify_popup_plus.svg?v=1630614892" alt="Plus symbol indicating that this link opens popup content"/>
                    </span>
			    </div>
                <div style="position: absolute; bottom: -10px; transform: scale(0.9); right: -106px;" > 
                <img style="width:66%;" src="https://cdn.shopify.com/s/files/1/0563/2848/7080/files/FAQ_identify_bidet_crop-05.svg?v=1632185627" alt=""/>
                </div>
          </div>
          <div class="support_popup_bottom_nav" role="button" tabindex="0" style="text-align:center;" onclick="onClickContactUs();">
                <div style="font-family: 'Frank Ruhl Libre'; font-size: 25px; font-weight: 500; color: #171717;
                padding: 10px; text-align:left;">
                    <p style="width:80%; margin-bottom: 5px;">Couldn't find what you need?</p>
                </div>
                <button class="contact_popup_button no-hover">Contact Us</button>
          </div>
        </div>
      </div>
      <div class="column">
      <div id="${css_selector}-FAQCategoryContent" style="height:100%;position:relative;width:100%;"></div>
      </div>
    </div>
    `;
    tab_content_wrapper.appendChild(tab_content);

    curr_product = removeSpace(curr_product);
    // Category and Subcategory
    // Create category left nav for current product
    for (let curr_category of categories[curr_product]) {
      const curr_category_with_space = curr_category;
      curr_category = removeSpace(curr_category);
      // Create <li> tag
      let curr_category_list = document.createElement("li");
      curr_category_list.setAttribute("class", "drop-nav");

      // Create div to anchor
      let curr_category_anchor = document.createElement("div");
      curr_category_anchor.setAttribute(
        "id",
        curr_product + "-" + curr_product + curr_category
      );
      document.getElementById("anchors").appendChild(curr_category_anchor);

      // Create <a> tag
      let curr_category_a = document.createElement("a");
      // Set query id for category
      curr_category_a.setAttribute("id", "cat-" +curr_product+ curr_category);
      curr_category_a.setAttribute(
        "href",
        "#" + curr_product + "-" + curr_product + curr_category
      );
      curr_category_a.onclick = function (e) {
        preventHashJump(e);
       
        openCat(curr_product + curr_category, curr_product, curr_category_with_space); //TODO:
        if (hashChangeDisabled) {
          return false;
        }
      };
      curr_category_a.textContent = curr_category_with_space;
      curr_category_list.appendChild(curr_category_a);

      /*
        Left Nav
        ANCHOR Subcategory
      */
      let curr_category_subcategory = document.createElement("ul");
      curr_category_subcategory.setAttribute(
        "style",
        "list-style-type: none; font-weight: normal;"
      );

      //Iterate through subcategory
      if (curr_category in subcategories) {
        for (let curr_subcategory of subcategories[curr_category]) {
          
          //remove NEO/NEO Plus specific subcategories @Jefferson
          if(curr_product == "NEOSeries" && curr_subcategory == "NEO Plus Models"){continue;}
          if(curr_product == "NEOPlusSeries" && curr_subcategory == "NEO Models"){continue;}
          if(curr_product == "NEOSeries" && curr_subcategory == "NEO Plus Features"){continue;}
          if(curr_product == "NEOPlusSeries" && curr_subcategory == "NEO Features"){continue;}
          
          let subcategory_list = document.createElement("li");
          subcategory_list.setAttribute("class", "subcat-drop-nav-li");

          // Anchors
          let subcat_anchor = document.createElement("div");
          subcat_anchor.setAttribute(
            "id",

            curr_product +
              "-" +
              curr_product + curr_category +
              "-" +
              curr_product + removeSpace(curr_subcategory)
          );
          
          document.getElementById("anchors").appendChild(subcat_anchor);

          // Create <a> tag for left nav subcat
          let subcategory_a = document.createElement("a");
          //set query id for subcategory
          subcategory_a.setAttribute(
            "id",
            "subcat-" + curr_product + removeSpace(curr_subcategory)
          );

          subcategory_a.setAttribute(
            "href",

            "#" +
              curr_product +
              "-" +
              curr_product+curr_category +
              "-" +
              curr_product+removeSpace(curr_subcategory)
          );
          // ANCHOR subcatA
          subcategory_a.onclick = (e) => {
            preventHashJump(e);         
            openSubCat(curr_subcategory, curr_product);
            if (hashChangeDisabled) {
              return false;
            }
          };
          subcategory_a.textContent = curr_subcategory;
          subcategory_list.appendChild(subcategory_a);
          curr_category_subcategory.appendChild(subcategory_list);
        }
      }
      curr_category_list.appendChild(curr_category_subcategory);

      document
        .getElementById(`${css_selector}-cat`)
        .appendChild(curr_category_list);
    }
    addSubcatToggleListener();
  }
};

/*
  Right FAQ Content
*/
const populateCatContents = () => {
  // FAQ Category contents
  for (let curr_product of products) {
    let css_selector = curr_product.replace(/\s+/g, "");
    const curr_product_with_space = curr_product;
    curr_product = removeSpace(curr_product);

    // <p> tag to display directory
    let curr_product_dir = document.createElement("p");
    curr_product_dir.setAttribute("id", curr_product + "-dir");
    curr_product_dir.setAttribute("class", "breadcrumbs-dir");
    
    let curr_product_href = "";
    
    
    if(curr_product === "NEOSeries"){
    	curr_product_href = "./customer-support#faq-NeoSeries";
    }
    else if(curr_product === "NEOPlusSeries"){
      curr_product_href = "./customer-support#neoPlusSeries";
    }
    else if (curr_product == "OtherLUXEProducts"){
        curr_product_href = "./customer-support#otherLUXEProducts"
    	//curr_product_href = "#" + curr_product + "-" + curr_product + "LUXEBidets";
    }
    else{
      curr_product_href = "#" + curr_product + "-" + curr_product + "OtherFAQs";
    }

    curr_product_dir.innerHTML = `<a href=${curr_product_href}>${curr_product_with_space}</a>`;
    document
      .getElementById(curr_product + "-FAQCategoryContent")
      .appendChild(curr_product_dir);

    let numSubcat = 0;
    let numQuestion = 0;

    for (let curr_category of categories[curr_product]) {
      numSubcat = 0;
      const curr_category_with_space = curr_category;
      curr_category = removeSpace(curr_category);

      // <div> tag to display each category's content
      let curr_category_div = document.createElement("div");
//       if(curr_category == "General"){
//         curr_category_div.setAttribute("id", curr_category+"-"+curr_product);
//       }
//       else{
      curr_category_div.setAttribute("id", curr_product + curr_category);
//       }
      curr_category_div.setAttribute("class", "colcontent");

      // <h2> tag for category's header
      let curr_category_header = document.createElement("h2");
      curr_category_header.textContent = curr_category_with_space;
      curr_category_div.appendChild(curr_category_header);
      
      // <p> tag for category's subtext
      let curr_category_subtext = document.createElement("p");
      curr_category_subtext.setAttribute("class","category-subtext");
      if(curr_category == "InstallationHelp"){
        curr_category_subtext.innerHTML = `${category_subtext[curr_category]} 
			The <a href="/pages/installation-neo" target="_blank">NEO Installation Guide</a> is also a great installation resource.`;
      }
      else{
      	curr_category_subtext.textContent = category_subtext[curr_category];
      }
      curr_category_div.appendChild(curr_category_subtext);
      

      // <div> tag for scrolling
      let scroll_div = document.createElement("div");
      scroll_div.setAttribute("class", "scroll-cat");

      if (curr_category in subcategories) {
        for (let curr_subcategory of subcategories[curr_category]) {
          numQuestion = 0;
          numSubcat += 1;

          const curr_subcategory_with_space = curr_subcategory;
          curr_subcategory = removeSpace(curr_subcategory);
          // add the questions
          let questions =
            faqdata[curr_product][curr_category][curr_subcategory];

          if (questions) {
            // <section>
            //   <button></button>
            //   <div></div>
            // </section>;

            // Section tag
            let subcat_section = document.createElement("section");
            subcat_section.setAttribute("id", "section-" + curr_product + curr_subcategory);
            subcat_section.setAttribute("class", "subcat-section");

            let subcat_header = document.createElement("div");
            subcat_header.setAttribute("class", "subcat-accordion");
            //  subcat_header.textContent = curr_subcategory; // TODO: no space

            let subcat_name = document.createElement("div");
            subcat_name.setAttribute("class", "subcat-name");

            subcat_name.textContent = curr_subcategory_with_space;
            subcat_header.appendChild(subcat_name);

            let subcat_arrow = document.createElement("img");
            // subcat_arrow.setAttribute("src", "./imgs/Collapse-Arrow.svg");
            subcat_arrow.setAttribute(
              "src",
              "https://cdn.shopify.com/s/files/1/0563/2848/7080/files/faq-accordion-whitearrow.svg?v=1632161024"
            );
            subcat_arrow.setAttribute("class", "accordion-arrow--subcat");
            subcat_header.appendChild(subcat_arrow);

            let curr_subcat_div = document.createElement("div");
            curr_subcat_div.setAttribute("class", "collapsible");
            curr_subcat_div.setAttribute("style", `height: 0`);
            curr_subcat_div.setAttribute("data-collapsed", "true");
            curr_subcat_div.setAttribute("aria-expanded", "false");
            for (let curr_question of questions) {
              numQuestion += 1;
              let curr_question_button = document.createElement("div");
              curr_question_button.setAttribute(
                "class",

                "accordion question-panel question-below-Subcategory"
              );

              //set query id for question button
              curr_question_button.setAttribute(
                "id",
                "question-" + curr_question.id
              );
              
              curr_question_button.setAttribute('onclick',`ga('send', 'event', 'faq-question', '${curr_question.question}')`);
              

              let curr_question_a = document.createElement("a");
              curr_question_a.textContent = curr_question.question;
              //curr_question_button.onClick = ANCHOR catQueA
              curr_question_a.onclick = (e) => {
                preventHashJump(e);
                if (
                  e.target.parentElement.parentElement.style.cssText.search(
                    "auto"
                  ) === -1
                ) {
                  const hash_level = document.location.hash.split("-");

                  document
                    .querySelector(
                      "#subcat-" + hash_level[2].replaceAll("%20", "")
                    )
                    .click();
                  preventHashJump(e);
                }
              };
              let curr_question_arrow = document.createElement("img");
              curr_question_arrow.setAttribute("class", "accordion-arrow");
              curr_question_arrow.setAttribute(
                "src",
                "https://cdn.shopify.com/s/files/1/0563/2848/7080/files/faq-accordion-blackarrow.svg?v=1632161146"
              );

              curr_subcat_div.appendChild(curr_question_button);

              curr_question_a.setAttribute(
                "href",
                "#" +
                  curr_product +
                  "-" +
                  curr_product + curr_category +
                  "-" +
                  curr_product+curr_subcategory +
                  "-question" +
                  curr_question.id
              );
              curr_question_button.appendChild(curr_question_a);
              curr_question_button.appendChild(curr_question_arrow);

              // Anchors ANCHOR questionA
              let curr_question_anchor = document.createElement("div");
              curr_question_anchor.setAttribute(
                "id",
                curr_product +
                  "-" +
                  curr_product+curr_category +
                  "-" +
                  curr_subcategory +
                  "-question" +
                  curr_question.id
              );
              document
                .getElementById("anchors")
                .appendChild(curr_question_anchor);

              // Answer panel
              let curr_question_div = document.createElement("div");
              // curr_question_div.setAttribute("class", "panel");
              curr_question_div.setAttribute(
                "class",
                "question-panel-answer--wrapper collapsible"
              );
              curr_question_div.setAttribute("data-collapsed", "true");
              curr_question_div.setAttribute("style", "height: 0");
              curr_question_div.setAttribute("aria-expanded", "false");
              // Answer panel inner
              let cur_question_div_inner = document.createElement("div");
              cur_question_div_inner.setAttribute(
                "class",
                "question-panel-answer--inner"
              );
              // curr_question_div.textContent = curr_question.answer;

              cur_question_div_inner.innerHTML = curr_question.answer;              
              if (typeof curr_question.hyper_link ==="object") {
                let answer = curr_question.answer;
                curr_question.hyper_text.forEach((text, i) => {
                  answer = answer.replace(
                    text,
                    `<a href="${curr_question.hyper_link[i]}">${text}</a>`
                  );
                });
                cur_question_div_inner.innerHTML = answer;
              }
              if(curr_question.popup_text !== ""){
                if(curr_subcategory === "ShippingandOrders"){
                  cur_question_div_inner.innerHTML = cur_question_div_inner.innerHTML.replace(
                   curr_question.popup_text,
                   `<a class="sno_popup_button">${curr_question.popup_text}</a>`
                  );
                }
                else if(curr_product !== "NEOSeries" && curr_product !== "NEOPlusSeries"){
                  cur_question_div_inner.innerHTML = cur_question_div_inner.innerHTML.replace(
                    curr_question.popup_text,
                    `<a class="nonNeo_popup_button">${curr_question.popup_text}</a>`
                  );
                }
                
                else{
                  cur_question_div_inner.innerHTML = cur_question_div_inner.innerHTML.replace(
                    curr_question.popup_text,
                    `<a class="trbs_popup_button">${curr_question.popup_text}</a>`
                  );
                }
              }

              curr_question_div.appendChild(cur_question_div_inner);
              curr_subcat_div.appendChild(curr_question_div);
            }

            // Contact Us banner at the end of the section (only seen when use scroll to the bottom)
            let topMarginQuestions = 318;
            if (numQuestion > 4) {
              topMarginQuestions = 33;
            }
            if(numQuestion == 2){
            	topMarginQuestions = 227;
            }
            if(numQuestion == 3){
            	topMarginQuestions = 135;
            }
            if(numQuestion == 4){
            	topMarginQuestions = 49;
            }

            // subcat_section.appendChild(subcat_heading);
            subcat_section.appendChild(subcat_header);
            subcat_section.appendChild(curr_subcat_div);
            scroll_div.appendChild(subcat_section);
          }
        }
      }

      // Top margin for contact us banner
      let topMargin = 105;
      
      if(curr_category === "General"){
      	topMargin = 203;
      }
      else{
        if(numSubcat == 1){
          topMargin = 314;
        }
        else if(numSubcat == 2){
      	  topMargin = 203;
        }
        else if (numSubcat == 3) {
          topMargin = 92;
        }
        else if(numSubcat == 4){
          topMargin: 105;
        }
        else{
          topMargin = 124;
        }
      }
      
        let mobile_contact_us_button = document.createElement("div");
        mobile_contact_us_button.innerHTML = `
        <div class="mobile-only support_popup_bottom_nav" onclick="onClickContactUs();">
                <div style="font-family: 'Frank Ruhl Libre'; font-size: 25px; font-weight: 500; color: #171717;
                padding: 10px; text-align:left;">
                    <p style="width:80%; margin-bottom: 5px;">Couldn't find what you need?</p>
                </div>
                <button type="button" class="contact_popup_button no-hover">Contact Us</button>
        </div>
        `;

      //curr_category_div.appendChild(contact_cat);
      // if(!document.querySelector("[class='contact cat']")) column.appendChild(contact_cat);
      curr_category_div.appendChild(scroll_div);
      curr_category_div.appendChild(mobile_contact_us_button);
      document
        .getElementById(curr_product + "-FAQCategoryContent")
        .appendChild(curr_category_div);
    }
  }

  addQuestionToggleListener();
  popupListener();
};

const openSubCat = (subcat, curr_product_name) => {
  // Update the directory
  let dir_p = document.getElementById(curr_product_name + "-dir");
  let product_dir = dir_p.childNodes[0];
  let cat_dir = dir_p.childNodes[2];

  //
  // Bug test for subcategory & questions toggle
  // @ Mingkun
  //
  // console.log("dir_p", dir_p);
  // console.log("product_dir", product_dir);
  // console.log("cat_dir", cat_dir);
  // console.log(dir_p);
  // console.log(dir_p.childNodes);
  // console.log("children", dir_p.children);
  // console.log(0, dir_p.childNodes[0]);
  // console.log(1, dir_p.childNodes[1]);
  // console.log(2, dir_p.childNodes[2]);
  // console.log(3, dir_p.childNodes[3]);

  dir_p.innerHTML = ""; // Clear the contents of the <p> tag
  dir_p.appendChild(product_dir);
  if (cat_dir) {
    let breadcrumbs_arrow = document.createElement("span");
    breadcrumbs_arrow.textContent = ">";
    breadcrumbs_arrow.style.margin = "0 17px";
    dir_p.append(breadcrumbs_arrow);
    cat_dir.classList.remove('breadcrumbs-dir-focus');
    dir_p.appendChild(cat_dir);
    
    let subcat_breadcrumbs = document.createElement('span');
    subcat_breadcrumbs.textContent = subcat.toUpperCase();
    subcat_breadcrumbs.classList.add('breadcrumbs-dir-focus');
    
    let breadcrumbs_arrow_subcat = document.createElement("span");
    breadcrumbs_arrow_subcat.textContent = ">";
    breadcrumbs_arrow_subcat.style.margin = "0 17px";
    dir_p.append(breadcrumbs_arrow_subcat);
    dir_p.append(subcat_breadcrumbs);
  }

  // Headers change
  let currid = `#section-${curr_product_name}${removeSpace(subcat)}`;
  let currid_element = document.getElementById(currid.substring(1)).parentNode.parentNode.childNodes[0];
  currid_element.textContent = subcat;
  currid_element.classList.add("subcat-header-style");
  

  $(currid).css("display", "block");
  $(currid).addClass("active"); // so header appears only when subcat is open
  
  // hide the category subtext
  let category_subtext = document.getElementsByClassName("category-subtext");
  for(let i = 0; i < category_subtext.length; i++){
   	category_subtext[i].style.display = "none";
  }

  // expand subcategory
  $(currid).children()[1].style.display = "block"; // to toggle the subcatogory
  $(currid).children()[1].style.height = "auto";
  $(currid).children()[1]["data-collapsed"] = "false";
  $(currid).children()[1]["aria-expanded"] = "true";

  // hide displays for section siblings
  let siblings = $(currid).siblings();
  for (let j = 0; j < siblings.length; j++) {
    if (siblings[j].tagName === "SECTION") {
      siblings[j].style.display = "none";
    }
  }

  let contact_banner_cat = document.getElementsByClassName("contact cat");
  for (cat of contact_banner_cat) {
    cat.style.display = "none";
  }

  // Active questions when click subcategory
  // $(`${currid} > .question-panel-answer--wrapper`).addClass("active");
};

const openCat = (cat, curr_product_name, cat_with_space) => {
  // Update the directory
  let breadCrumbs = document.getElementById(curr_product_name + "-dir");
  let breadCrumbs_level = breadCrumbs.firstChild;
  breadCrumbs.innerHTML = ""; // clear the content of the <p> tag
  breadCrumbs.appendChild(breadCrumbs_level); // append the first child (product)
  
  let breadcrumbs_arrow = document.createElement("span");
  breadcrumbs_arrow.textContent = ">";
  breadcrumbs_arrow.style.margin = "0 17px";
  breadCrumbs.append(breadcrumbs_arrow);

  let cat_breadCrumb = document.createElement("a");
  cat_breadCrumb.setAttribute("href", "#" + curr_product_name + "-" + cat);
  cat_breadCrumb.textContent = cat_with_space;
  cat_breadCrumb.classList.add("breadcrumbs-dir-focus");
  breadCrumbs.appendChild(cat_breadCrumb);

//   if(cat == "General"){
//     cat = cat + "-" +curr_product_name;
//   }
  // Headers
  document.getElementById(cat).childNodes[0].textContent = cat_with_space;
  document.getElementById(cat).childNodes[0].classList.remove("subcat-header-style");
  
  // Display the category subtext
  let category_subtext = document.getElementsByClassName("category-subtext");
  for (let i = 0; i < category_subtext.length; i++){
  	category_subtext[i].style.display = "block";
  }

  // Change content based on category
  let colcontent = document.getElementsByClassName("colcontent");
  for (let i = 0; i < colcontent.length; i++) {
    colcontent[i].style.display = "none";
  }
  document.getElementById(cat).style.display = "block";
  
  let section_children = document.getElementById(cat).children;

  let section_children_scrollcat = section_children[section_children.length - 1].children;
  for (let sections of section_children_scrollcat) {
    sections.style.display = "block";
  }

  // Closes all active accordian
  let accordion = document.getElementsByClassName("accordion question-panel");
  for (let i = 0; i < accordion.length; i++) {
    if ($(accordion[i]).hasClass("active")) {
      document.querySelector("#" + accordion[i].getAttribute("id")).click();
    }
  }

  $(".subcat-section").removeClass("active"); // remove the subcat header when leaving subcat

  // Remove all active class for subcategory accordion
  const subcatAccordion = document.getElementsByClassName("subcat-accordion");
  for (let i = 0; i < subcatAccordion.length; i++) {
    subcatAccordion[i].classList.remove("active");
  }

  // Close all collapsible div
  const collapsible = document.getElementsByClassName("collapsible");
  for (let i = 0; i < collapsible.length; i++) {
    collapsible[i].style.height = 0;
    collapsible[i].setAttribute("data-collapsed", "true");
    collapsible[i].setAttribute("aria-expanded", "false");
  }
  
  // Remove the active class for the subcat in nav
  const dropnav_li = document.getElementsByClassName("subcat-drop-nav-li");
  for (let i = 0; i < dropnav_li.length; i++){
  	dropnav_li[i].classList.remove('active');
  }
  
};

const handleUrl = (e) => {
  hashChangeDisabled = true;
  let hash = document.location.hash;
  try{
    if (hash) {
      let hash_level = hash.substring(1).split("-");
      // Opening product tabs
      if (hash_level[0] === "faq") {
        document.querySelector("#tab-" + hash_level[1]).click();
      } else if (hash_level.length === 2) {
        document.querySelector("#tab-" + hash_level[0]).click();
        document.querySelector("#cat-" + hash_level[1]).click();
      } else if (hash_level.length === 3) {
        document.querySelector("#tab-" + hash_level[0]).click();
        document.querySelector("#cat-" + hash_level[1]).click();
        if (hash_level[2]=='contact') {
          // Scroll to contact form banner
          document.querySelector('#section-NEOSeriesMissingorBrokenParts').scrollIntoView();
        } else{
          document
            .querySelector("#subcat-" + hash_level[2].replaceAll("%20", ""))
            .click();
        }
      } else if (hash_level.length === 4) {
        document.querySelector("#tab-" + hash_level[0]).click();
        document.querySelector("#cat-" + hash_level[1]).click();
        document
          .querySelector("#subcat-" + hash_level[2].replaceAll("%20", ""))
          .click();
        document.querySelector("#question-" + hash_level[3].substring(8)).click();
      } else {
        console.log('404');
//         document.location.href = '/404';
      }
    }
    else{
    	document.location.href = '/pages/customer-support';
    }
  } catch(err){
  	document.location.href = '/404';
  }
  hashChangeDisabled = false;
};

const addSubcatToggleListener = () => {
  $(".drop-nav a").on("click", function (e) {
    //e.preventDefault();
    // don't allow the event to fire horizontally or vertically up the tree
    //e.stopImmediatePropagation();
    // switch the active class that you can use to display the child
    $(this).parent().addClass("active"); // so the cat wont collapse
    $(this).parent().siblings().removeClass("active");

    //reshow all category siblings that got hidden when selecting a specific one @Jefferson
    let category = $(this).attr("id");
    category = category.slice(4);
    $("#" + category + " .scroll-cat section").show(); 
  });
};

/*
  Add accordion toggle listener
*/
let addQuestionToggleListener = () => {
  var acc = document.getElementsByClassName("subcat-accordion");
  var qacc = document.getElementsByClassName("question-panel");

  // Subcategory toggle listener
  for (let i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      this.classList.toggle("active");
      //const panel = this.nextElementSibling;
      const parent = this.parentElement;
      const section_name = parent.id.split("section-")[1];
      
      document.getElementById('subcat-'+section_name).click();

//       addCollapseToElement(panel);
    });
  }

  // Question toggle listener
  for (let i = 0; i < qacc.length; i++) {
    qacc[i].addEventListener("click", function (e) {
     
      if (document.location.hash.search("question")!==-1)e.preventDefault()
      qacc[i].scrollIntoView({
        behavior: "smooth",
        inline: "nearest",
        block: "center",
      });
      // Subcategory not active yet
      if (!$(this).closest("section").hasClass("active")) {
        if ($(this).childNodes) $(this).childNodes[0].click();
      } else if ($(this).closest("section").hasClass("active")) {
        // Subcategory active, just toggle panel

        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        var linksInQuestion = panel.getElementsByTagName("a");

        if ($(this).hasClass("active")) {
          panel.setAttribute("data-collapsed", "true");
        } else {
          panel.setAttribute("data-collapsed", "false");
        }

        addCollapseToElement(panel);
      }
    });
  }
};

// identify_popup
//
function openIdentify() {
  document.getElementById("identify_pop").style.display = "block";
  document.getElementById("open_identify_pop").setAttribute("aria-expanded", "true");
//   document.getElementById("identifyparts").style.display = "none";
}
function closeIdentify() {
  document.getElementById("identify_pop").style.display = "none";
  document.getElementById("open_identify_pop").setAttribute("aria-expanded", "false");
//   document.getElementById("identifyparts").style.display = "block";
}
function rightScroll() {
  document.getElementById("pop_img").scrollBy(900, 0);
}
function leftScroll() {
  document.getElementById("pop_img").scrollBy(-900, 0);
}

/*
  Accordion open & close smooth animtion JS function
*/
// Expand & collapse element helper function
function addCollapseToElement(element) {
  const isCollapsed = element.getAttribute("data-collapsed") === "true";

  if (isCollapsed) {
    expandSection(element);
    element.setAttribute("data-collapsed", "false");
    element.setAttribute("aria-expanded", "true");
  } else {
    collapseSection(element);
  }
}
// Collapse Element helper function
function collapseSection(element) {
  // get the height of the element's inner content, regardless of its actual size
  var sectionHeight = element.scrollHeight;

  // temporarily disable all css transitions
  var elementTransition = element.style.transition;
  element.style.transition = "";

  // on the next frame (as soon as the previous style change has taken effect),
  // explicitly set the element's height to its current pixel height, so we
  // aren't transitioning out of 'auto'
  requestAnimationFrame(function () {
    element.style.height = sectionHeight + "px";
    element.style.transition = elementTransition;

    // on the next frame (as soon as the previous style change has taken effect),
    // have the element transition to height: 0
    requestAnimationFrame(function () {
      element.style.height = 0 + "px";
    });
  });

  // mark the section as "currently collapsed"
  element.setAttribute("data-collapsed", "true");
  element.setAttribute("aria-expanded", "false");
}
// Expand element helper function
function expandSection(element) {
  // get the height of the element's inner content, regardless of its actual size
  var sectionHeight = element.scrollHeight;

  // have the element transition to the height of its inner content
  element.style.height = sectionHeight + "px";

  // when the next css transition finishes (which should be the one we just triggered)
  element.addEventListener("transitionend", function (e) {
    // remove this event listener so it only gets triggered once
    element.removeEventListener("transitionend", arguments.callee);

    // remove "height" from the element's inline styles, so it can return to its initial value
    // element.style.height = null;
  });

  // mark the section as "currently not collapsed"
  element.setAttribute("data-collapsed", "false");
}

// ANCHOR tabmove
(function tabMove() {
  const tabWrapper = document.querySelector("#tab-wrapper");
  let mouseDown = false,
    pointerStart,
    scrollStart;
  tabWrapper.ontouchstart = (e) => {
    mouseDown = true;
    pointerStart = e.touches[0].pageX;
    scrollStart = tabWrapper.scrollLeft;
  };
  tabWrapper.ontouchmove = (e) => {
    e.preventDefault();
    if (!mouseDown) return;

    tabWrapper.scrollLeft = scrollStart + (pointerStart - e.touches[0].pageX);
  };
})();